var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMinePhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_mine_phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4E2A\\u4EBA\\u4E2D\\u5FC3-\\u6211\\u7684\\u4FE1\\u606F",
    transform: "translate(-478, -341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_mine_phone",
    transform: "translate(475, 339)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-10",
    transform: "translate(3, 2)",
    fill: "#999999",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7894737,0 C14.1149474,0 16,1.87409302 16,4.18604651 L16,13.8139535 C16,16.125907 14.1149474,18 11.7894737,18 L4.21052631,18 C1.88505263,18 0,16.125907 0,13.8139535 L0,4.18604651 C0,1.87409302 1.88505263,0 4.21052631,0 L11.7894737,0 Z M11.7894737,1.46511629 L4.21052631,1.46511629 C2.73716116,1.46511629 1.5281829,2.62465396 1.47536842,4.08851164 L1.4736842,4.18604651 L1.4736842,13.8139535 C1.4736842,15.2787526 2.6400028,16.4807019 4.11242104,16.5332093 L4.21052631,16.5348837 L11.7894737,16.5348837 C13.2628388,16.5348837 14.4718171,15.3753461 14.5246316,13.9114884 L14.5263158,13.8139535 L14.5263158,4.18604651 C14.5263158,2.72124744 13.3599972,1.51929811 11.887579,1.4667907 L11.7894737,1.46511629 Z",
    id: "\\u5F62\\u72B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,14.6511628 C7.18610668,14.6511628 6.52631578,13.9952079 6.52631578,13.1860465 C6.52631578,12.3768851 7.18610668,11.7209302 8,11.7209302 C8.81389332,11.7209302 9.47368422,12.3768851 9.47368422,13.1860465 C9.47368422,13.9952079 8.81389332,14.6511628 8,14.6511628 Z",
    id: "\\u8DEF\\u5F84"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMinePhone);
export default __webpack_public_path__ + "static/media/icon_mine_phone.svg";
export { ForwardRef as ReactComponent };